import { mxResultData } from 'config/config';

// {"validRequest":true,"options":{"49efbbb7-0b4c-4a5e-aa7a-27a0e33949a4":4,"f49ef448-8ed3-4b06-aa0e-5db5f04a97c7":4},"correctAnswer":true}
// {"validRequest":true,"answerUUID":"964bff70-11bc-4d64-b379-b9a843dac9ec","options":{"964bff70-11bc-4d64-b379-b9a843dac9ec":8,"58c5a458-11b9-4958-9a61-53aea1b49fe4":3,"e95bb180-e86a-4f49-b1f2-bfd2aa31210f":7,"d453a56a-b112-46e7-bbc7-d1b280d652ff":3,"b8caf7b8-68ff-4d81-813e-203da64ff824":1,"7d36069e-d980-434d-8495-88bcbd058ada":3},"correctAnswer":true}
export const getResponseResult = (questionUUID, optionUUID, questionType) => {
    if(questionType !== 'quiz' && questionType !== 'poll') return { correctAnswer: true, validRequest: true }
    const result = mxResultData[questionUUID];
    result['validRequest'] = true;
    result['correctAnswer'] = true;
    if (!!mxResultData[questionUUID]['answerUUID']) result['correctAnswer'] = mxResultData[questionUUID]["answerUUID"] === optionUUID;
    return result;
};
